import env from "~/libs/env.js";

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.path.startsWith('/business-credit-cards')) {
    const nuxtApp = useNuxtApp()
    return nuxtApp.runWithContext(() => navigateTo(`${env('hpBaseUrl')}/business-loans/business-credit-card/`, { external: true, replace: true }))
  }
})
